
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sa/purchase-pass",
      function () {
        return require("private-next-pages/sa/purchase-pass.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sa/purchase-pass"])
      });
    }
  